import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const defaultColor = "#D3D3D3";

export const CommentsIcon = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox={`0 0 32.46 29.35`}>
            <path
                d="M26,39.48a6.86,6.86,0,0,1-1-.07l-1.15-.19V35.7C15.63,35.07,9.16,29.56,9.16,23c0-7.07,7.29-12.82,16.24-12.82S41.63,15.88,41.63,23c0,4.27-2.64,8.2-7.09,10.59A9.56,9.56,0,0,1,26,39.48ZM25.4,12.85C18,12.85,11.89,17.38,11.89,23s6,10,13.32,10.08l1.35,0v3.66c1.5-.17,4.12-1,5.68-4.69l.19-.46.45-.23c3.77-1.89,6-5,6-8.38C38.9,17.38,32.84,12.85,25.4,12.85Z"
                transform="translate(-9.16 -10.13)"
            />
        </SvgIcon>
    );
};

export const RefreshIcon = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox="0 0 31.51 27.78" fontSize="large">
            <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
        </SvgIcon>
    );
};

export const LikesIcon = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox={`0 0 31.51 27.78`}>
            <path
                d="M25.65,39.06l-.91-.75c-1-.87-2.31-1.76-3.66-2.7-4-2.8-8.56-6-10.46-10.77-2.3-5.84.57-10.16,3.73-12.08a9.37,9.37,0,0,1,11.06.71A9.71,9.71,0,0,1,34.94,12a9.12,9.12,0,0,1,6.36,8.37c.19,7-6,11.49-11,15.08a45.29,45.29,0,0,0-3.74,2.87ZM19.51,14a7.41,7.41,0,0,0-3.75,1.05c-2.36,1.44-4.29,4.49-2.6,8.75,1.59,4,5.78,7,9.48,9.55,1,.73,2,1.42,2.94,2.12.93-.75,2-1.51,3.11-2.31C33.16,30,38.73,26,38.58,20.4A6.48,6.48,0,0,0,34,14.52a6.83,6.83,0,0,0-7.59,1.75l-1,1.2-1-1.19A6.33,6.33,0,0,0,19.51,14Z"
                transform="translate(-9.79 -11.29)"
            />
        </SvgIcon>
    );
};
export const LikesIconComments = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox={`0 0 31.51 27.78`} fontSize="small">
            <path
                d="M25.65,39.06l-.91-.75c-1-.87-2.31-1.76-3.66-2.7-4-2.8-8.56-6-10.46-10.77-2.3-5.84.57-10.16,3.73-12.08a9.37,9.37,0,0,1,11.06.71A9.71,9.71,0,0,1,34.94,12a9.12,9.12,0,0,1,6.36,8.37c.19,7-6,11.49-11,15.08a45.29,45.29,0,0,0-3.74,2.87ZM19.51,14a7.41,7.41,0,0,0-3.75,1.05c-2.36,1.44-4.29,4.49-2.6,8.75,1.59,4,5.78,7,9.48,9.55,1,.73,2,1.42,2.94,2.12.93-.75,2-1.51,3.11-2.31C33.16,30,38.73,26,38.58,20.4A6.48,6.48,0,0,0,34,14.52a6.83,6.83,0,0,0-7.59,1.75l-1,1.2-1-1.19A6.33,6.33,0,0,0,19.51,14Z"
                transform="translate(-9.79 -11.29)"
            />
        </SvgIcon>
    );
};
export const ShareIcon = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox={`0 0 48.46 27.3`}>
            <path
                d="M15,31.13A11.49,11.49,0,0,0,18.13,28a5.44,5.44,0,0,0-.92-7.55,6.63,6.63,0,0,0-8.84,0A5.65,5.65,0,0,0,6.4,25a7.14,7.14,0,0,0,3.15,5.21c.49.35,1,.65,1.43.92-4.71.54-9.33-3.35-9.38-3.39L.68,28.8c.21.18,5.21,4.4,10.6,3.7a8.87,8.87,0,0,0,1.78-.42,9.8,9.8,0,0,0,3.4.63c3.63,0,6.5-2.19,8.54-4.51l-1.07-.94C21.16,30.43,18.17,31.73,15,31.13ZM10.34,29a5.75,5.75,0,0,1-2.53-4.12,4.24,4.24,0,0,1,1.52-3.46,4.81,4.81,0,0,1,3.33-1.31,5.65,5.65,0,0,1,3.62,1.35A4,4,0,0,1,17,27.14a9.38,9.38,0,0,1-3.9,3.41A13.52,13.52,0,0,1,10.34,29Z"
                transform="translate(-0.68 -11.64)"
            />
            <path
                d="M48.78,12.81c-.35-.56-1.27-1.45-3.41-1.08L20,16.1c-2.09.36-2.67,1.35-2.79,2.11s.13,1.89,2,2.87l5,2.59a7,7,0,0,1,3.19,4.57l1,7.72c.28,2.17,1.39,2.76,2,2.92a2,2,0,0,0,.52.06,3.28,3.28,0,0,0,2.63-1.7L48.29,16.36C49.54,14.58,49.14,13.37,48.78,12.81ZM20.62,18.75l24.22-4.17L28.68,24.33a9,9,0,0,0-3.22-3.07ZM31.35,35.67a2.21,2.21,0,0,1-.19.26,2.29,2.29,0,0,1-.06-.32l-1-7.72a7.88,7.88,0,0,0-.55-2l15.08-9.09Z"
                transform="translate(-0.68 -11.64)"
            />
        </SvgIcon>
    );
};

export const VotesIcon = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox={`0 0 34.36 29.34`}>
            <path
                d="M41.77,12.24l-.83-.89a2.47,2.47,0,0,0-1.8-.75,3,3,0,0,0-2.06.84L18.22,29.13,13.59,24.2a3,3,0,0,0-2.17-1,2.47,2.47,0,0,0-1.68.64l-.88.83a2.43,2.43,0,0,0-.75,1.89,3,3,0,0,0,.83,2l4.63,4.93,0,0,4.36,4.65L41.44,16.09A2.75,2.75,0,0,0,41.77,12.24Z"
                transform="translate(-8.05 -10.13)"
            />
        </SvgIcon>
    );
};

export const AddOptionIcon = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox={`0 0 44.1 43.1`}>
            <path
                d="M22,0.5C10.3,0.5,0.9,9.9,0.9,21.6c0,11.6,9.4,21.1,21.1,21.1c11.7,0,21.1-9.4,21.1-21.1
	C43.1,9.9,33.6,0.5,22,0.5z M31.1,23.8h-6.8v6.8c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3v-6.8h-6.8c-1.3,0-2.3-1-2.3-2.3
	c0-1.3,1-2.3,2.3-2.3h6.8v-6.8c0-1.3,1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3v6.8h6.8c1.3,0,2.3,1,2.3,2.3C33.3,22.8,32.3,23.8,31.1,23.8
	z"
            />
        </SvgIcon>
    );
};

export const ParticipationIcon = (
    props: React.ComponentProps<typeof SvgIcon>
) => {
    const { sx, ...rest } = props;

    return (
        <SvgIcon
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            strokeLinecap="round"
            strokeLinejoin="round"
            sx={[{ fill: "none" }, ...(Array.isArray(sx) ? sx : [sx])]}
            {...rest}
        >
            <circle cx="12" cy="8" r="2.8" />
            <path d="M6.5 19.5c0-3 2.5-5.2 5.5-5.2s5.5 2.2 5.5 5.2" />
            <circle cx="5" cy="9.5" r="2" />
            <path d="M1.8 18.5c0-2.2 1.4-3.8 3.4-4.1" />
            <circle cx="19" cy="9.5" r="2" />
            <path d="M22.2 18.5c0-2.2-1.4-3.8-3.4-4.1" />
        </SvgIcon>
    );
};

export const UploadIcon = ({ color = defaultColor }) => {
    return (
        <SvgIcon htmlColor={color} viewBox={`0 0 44.1 43.1`}>
            <path d="M8.7,18.5h5.4v11.6c0,1.2,1,2.2,2.2,2.2h11.5c1.2,0,2.2-1,2.2-2.2V18.5h5.4c2.1,0,3.1-2.5,1.7-4L23.7,1.1c-0.9-0.9-2.4-0.9-3.3,0L7,14.5C5.6,16,6.6,18.5,8.7,18.5z" />
            <path d="M39.7,37.4H4.5c-0.6,0-1.2,0.5-1.2,1.2v2.9c0,0.6,0.5,1.2,1.2,1.2h35.1c0.6,0,1.2-0.5,1.2-1.2v-2.9C40.8,37.9,40.3,37.4,39.7,37.4z" />
        </SvgIcon>
    );
};
